const initialState = null;

export default function (state = initialState, action) {
  switch (action.type) {
    case 'SET_SUBDOMAIN':
      return action.subdomain;
    default:
      return state;
  }
}